import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Sync Item Groups from GAINS
 *
 * Rebuilds the organization's item groups from the GAINS departments
 * (INITINFC `gidept`) in every division's INITINFC mirror: one group per
 * department code, and every catalog product in the departments GAINS lists
 * it under. Groups are kept and only memberships are rebuilt, so a group's id
 * never changes and the supply network lanes and "doesn't buy" lists that name
 * it keep working.
 *
 * It reads every mirror at once, so run it once after the INITINFC files
 * land, never inside the ingest's per-file fanout. The "Supply Network GAINS
 * Sync" workflow runs it daily after the INITINFC ingest.
 */
export const syncItemGroupsFromGainsStep = defineStepConfig({
  type: "sync_item_groups_from_gains",
  name: "Sync Item Groups from GAINS",
  description:
    "Rebuilds the organization's item groups from the GAINS departments (INITINFC gidept) in every division's mirror: one group per department code, each catalog product in its department. Group ids never change, so supply network lanes and buying exceptions keep working. Run it once after the INITINFC files land.",
  category: "Transformation",
  libraryModule: "Procurement",
  inputSchema: z.object({}),
  outputSchema: z.object({
    mirrors: z.number().describe("INITINFC mirrors read"),
    groups: z.number().describe("Department item groups after the sync"),
    memberships: z.number().describe("Product memberships after the sync"),
  }),
  configSchema: z.object({}),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "30 minutes",
    retry: { maximumAttempts: 2 },
  },
});
